import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * SEC-002 — Banner persistente di sessione impersonata.
 *
 * I claim vengono salvati da AuthContext quando l'admin apre la webapp come
 * utente impersonato (sessionStorage: impersonated_by / impersonated_user).
 * Se la sessione NON e' impersonata il componente non renderizza nulla.
 * Si attende che l'auth sia risolta (loading) per evitare flicker al mount.
 */
export default function ImpersonationBanner() {
  const { loading, logout } = useAuth();
  const navigate = useNavigate();
  const [imp, setImp] = useState(null);

  useEffect(() => {
    if (loading) return; // attendi che la sessione sia caricata (no flicker)
    const impUser = sessionStorage.getItem('impersonated_user') || '';
    const impBy = sessionStorage.getItem('impersonated_by') || '';
    setImp(impUser || impBy ? { impUser, impBy } : null);
  }, [loading]);

  if (loading || !imp) return null;

  const termina = () => {
    sessionStorage.removeItem('impersonated_by');
    sessionStorage.removeItem('impersonated_user');
    logout();
    navigate('/auth/login');
  };

  return (
    <div
      role="alert"
      style={{
        flexShrink: 0,
        background: 'rgb(var(--accent))',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '8px 16px',
        fontSize: 13,
        fontWeight: 500,
        zIndex: 30,
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 8, textAlign: 'center' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 11l-3 3-1.5-1.5" />
        </svg>
        Sessione impersonata
        {imp.impUser ? (
          <>
            &nbsp;— stai operando come <strong>&nbsp;{imp.impUser}</strong>
          </>
        ) : null}
        {imp.impBy ? <span style={{ opacity: 0.85 }}>&nbsp;(admin: {imp.impBy})</span> : null}
      </span>
      <button
        type="button"
        onClick={termina}
        aria-label="Termina impersonazione"
        style={{
          background: 'rgba(255,255,255,0.2)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.6)',
          borderRadius: 8,
          padding: '7px 14px',
          fontSize: 12,
          fontWeight: 500,
          cursor: 'pointer',
          minHeight: 36,
          flexShrink: 0,
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
      >
        Termina impersonazione
      </button>
    </div>
  );
}
